import auth0 from "auth0-js";
export default class Auth0Service {
  auth0 = new auth0.WebAuth({
    domain:process.env.REACT_APP_AUTH0_DOMAIN,
    clientID:process.env.REACT_APP_AUTH0_CLIENT_ID,
    audience:process.env.REACT_APP_AUTH0_AUDIENCE,
    redirectUri:process.env.REACT_APP_AUTH0_REDIRECT_URI,
    scope: process.env.REACT_APP_AUTH0_SCOPE,
    responseType:process.env.REACT_APP_AUTH0_RESPONSE_TYPE,
    grantType:process.env.REACT_APP_AUTH0_GRANT_TYPE
  });

  constructor() {
    this.signin = this.signin.bind(this);
  }

  signin(username, password) {
    let _this = this;
    
    return new Promise((resolve, reject) => {
      this.auth0.client.login(
        { realm:"Username-Password-Authentication", username, password },
        function (err, authResult) {
          if (err) {
            return reject(err);
          }
          // setSession(authResult);
          _this.auth0.client.userInfo(
            authResult.accessToken,
            async (err, user) => {
              if (err) {
                return reject(err);
              }
              let role = user["http://nft/user_metadata"]["role"]
              if(role != "admin"){
                return reject({
                  code: "no access",
                  description:"permission denied",
                  original: {
                    response:{
                      text:{error_description:"permission denied"}
                    }
                  },
                  statusCode: 403
                })
              }
              return resolve({
                ...authResult,
                userDetails: user,
                userMetaData: user,
              });
            }
          );
        }
      );
    });
  }
}

